import React from "react";
import EnvironmentSelector from "../common/EnvironmentSelector";

const TopNav = ({ activeTab, onTabChange }) => {
  return (
    <div className="flex items-center justify-between px-4 py-2 bg-[#fafafa] border-b border-[#e0e0e0] z-50 font-apple">
      <div className="flex items-center gap-4">
        {/* Empty space for future content */}
      </div>

      <div className="flex items-center gap-4">
        <EnvironmentSelector />
      </div>
    </div>
  );
};

export default TopNav;
